module.exports = __webpack_public_path__ + "static/img/Republic_of_China_Police_Station_Logo.93ce6a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Republic_of_China_Police_Station_Logo.svg
// module id = 1186
// module chunks = 1